var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRateSomething(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 29,
    rx: 5.5,
    fill: "#F7CE46"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 29,
    rx: 5.5,
    stroke: "#F7CE46"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4755 6.46353L18.9511 6.30902C18.6517 5.38771 17.3483 5.38771 17.0489 6.30902L17.5245 6.46353L17.0489 6.30902L15.3916 11.4098H10.0283C9.05955 11.4098 8.65678 12.6494 9.44049 13.2188L13.7795 16.3713L12.1221 21.4721C11.8228 22.3934 12.8773 23.1596 13.661 22.5902L18 19.4377L22.339 22.5902C23.1227 23.1596 24.1772 22.3934 23.8779 21.4721L22.2205 16.3713L26.5595 13.2188C27.3432 12.6494 26.9404 11.4098 25.9717 11.4098H20.6084L18.9511 6.30902L18.4755 6.46353Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9998 6.28021C17.9998 6.00412 17.7629 5.76901 17.5194 5.8992C17.3146 6.0087 17.1438 6.19388 17.054 6.45473L15.5909 10.7029C15.452 11.1064 15.0722 11.3773 14.6454 11.3773H10.0404C9.05768 11.3773 8.66445 12.6465 9.47506 13.2021L13.0985 15.6858C13.4696 15.9402 13.6251 16.411 13.4786 16.8363L12.0713 20.9226C11.7575 21.8338 12.7873 22.618 13.5822 22.0731L17.4341 19.4328C17.4621 19.4136 17.4909 19.396 17.5202 19.3799C17.7626 19.2475 17.9998 19.0337 17.9998 18.7575V6.28021Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateSomething);
export default __webpack_public_path__ + "static/media/Rate-Something.88b49eccde6d38d2a3f459dc1b5eeaa8.svg";
export { ForwardRef as ReactComponent };